/* ag26 "Pairs well with" sales tracking (30 Sep 2026).
   When a shopper adds a product from a "Pairs well with" box, remember which product suggested it.
   At checkout the bag link carries the list as a hidden order note (_ag_pairs), so AGOS can count
   how many times each pairing was actually bought. Format: variantId:productId<sourceId|sourceId;... */
(function () {
  if (window.__agPT) return; window.__agPT = 1;
  var PID = { freedom: [7027642859592], set: [7031285645384, 7034113884232], light: [6568961638472], kids: [4595800440904],
    vest: [6942057758792], jogger: [7027643514952], rnd5: [6942737662024], sq5: [6942739464264], sq8: [6942739955784],
    wr5: [6942741495880], wr8: [6942740545608], precut: [6943175376968, 6943142936648], pack: [5854774427720],
    stops: [4595774947400], slider: [6942777245768], pulls: [4595776618568, 6952948596808] };
  var KEY = 'ag-pairs', T = {}, pending = null;
  try { T = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { T = {}; }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(T)); } catch (e) {} }
  function prodsFor(pred) { var D = window.SHOP, out = []; if (!D || !D.products) return out;
    D.products.forEach(function (p) { if (pred(p)) (PID[p.key] || []).forEach(function (x) { if (out.indexOf(x) < 0) out.push(x); }); }); return out; }
  function sources(box) {
    if (box.id === 'ppPairs') { var n = (document.getElementById('ppName') || {}).textContent || ''; n = n.trim();
      return prodsFor(function (p) { return p.name === n; }); }
    var bag = window.agBag ? window.agBag() : [], ids = {}; bag.forEach(function (b) { ids[b.id] = 1; });
    return prodsFor(function (p) { return (p.vars || []).some(function (v) { return ids[v.id]; }); });
  }
  function wrap() {
    if (!window.agBagAdd || window.agBagAdd.__pt) return;
    var orig = window.agBagAdd;
    window.agBagAdd = function (it) {
      if (pending && it && it.id && Date.now() - pending.t < 3000) { T[it.id] = { p: pending.p, s: pending.s, t: Date.now() }; save(); }
      pending = null; return orig.apply(this, arguments);
    };
    window.agBagAdd.__pt = 1;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.pwadd'); if (!b) return;
    var box = b.closest('#ppPairs,#bagPairs'), li = b.closest('li[data-p]'); if (!box || !li) return;
    wrap(); pending = { p: +li.dataset.p, s: sources(box), t: Date.now() };
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('#bagGo'); if (!a) return;
    var bag = window.agBag ? window.agBag() : [], parts = [];
    bag.forEach(function (x) { var r = T[x.id]; if (r && r.s && r.s.length) parts.push(x.id + ':' + r.p + '<' + r.s.join('|')); });
    var h = a.getAttribute('href') || ''; if (!/\/cart\//.test(h)) return;
    h = h.replace(/[?&]attributes%5B_ag_pairs%5D=[^&]*/, '');
    if (parts.length) h += (h.indexOf('?') > -1 ? '&' : '?') + 'attributes%5B_ag_pairs%5D=' + encodeURIComponent(parts.join(';'));
    a.setAttribute('href', h);
  }, true);
})();
